import React from "react";
import Logo from "./Logo";

const Footer = () => {
  return (
    <footer style={footerStyle}>
      <div style={footerContainer}>
        {/* Footer Content */}
        <div>
         <Logo/>
        </div>

       

        {/* <div>
          <h3>Contact Us</h3>
          <p>Email: info@example.com</p>
          <p>Phone: +1 234 567 890</p>
        </div> */}
      </div>

      <div style={footerBottom}>
        <p>&copy; {new Date().getFullYear()} Ampstek Pay All Rights Reserved.</p>
      </div>
    </footer>
  );
};

// Inline styles for simplicity
const footerStyle = {
  backgroundColor: "#fff",
  color: "#000",
  padding: "20px 0",
  textAlign: "center",
};

const footerContainer = {
  display: "flex",
  justifyContent: "space-around",
  padding: "10px 20px",
};

const footerBottom = {
  marginTop: "20px",
  borderTop: "1px solid #444",
  paddingTop: "10px",
};



export default Footer;
